export default {
  en: {
    'all': 'All',
    'avg-weekly-hrs': 'Avg. Weekly Hrs',
    'only-active': 'Only Active',
    'employee-look-back': 'Employee Look Back',
    'search-here': 'Search here',
    'search-instructions': "Search using the first 4 letters of the employee's last name OR the last 4 digits of the employee's SSN. For names shorter than 4 letters, add spaces to reach 4 characters.",
    'employee-lookup': 'Employee Time Punches',
    'please-enter-a-value': 'Please enter a value',
    'please-enter-4-letters': 'Please enter 4 letters',
    'please-enter-4-numbers': 'Please enter 4 numbers',
    'please-do-not-use-special-characters': 'Please do not use any special characters',
    'employees': 'Employees',
    'emp-pay-details': 'Employee Pay Details',
    'federal': 'Fed.',
    'state': 'State',
    'local': 'Local',
    'marital-status': 'Marital Status',
    'tax-exempt': 'Tax Exempt',
    'exemptions': 'Exemptions',
    'additional-withholding': 'Additional Withholding $',
    'fed-multi-job': 'Fed. Multi Job',
    'fed-qual-child': 'Fed. Qual Child $',
    'fed-other-dep': 'Fed. Other Dep $',
    'fed-total-dep': 'Fed. Total Dep $',
    'fed-other-income': 'Fed. Other Income',
    'fed-deductions': 'Fed. Deductions',
    'hire-card-store-num': 'Location',
    'new-hires-since': 'New Hires Since',
    'new-hires-found': 'New Hires Found',
    'new-hires': 'New Hires',
    'overtime-audit': 'Overtime Audit',
    'no-pay-details-found': 'No pay details have been found.',
    'pay-cycle': 'Pay Cycle',
    'pay-cycle-status': 'Pay Cycle Status',
    'current-pay-cycle': 'Current Pay Cycle',
    'most-recent-released': 'Most Recent Released',
    'next-pay-cycle': 'Next Pay Cycle',
    'active-employee-with-no-punches': 'Active Employee With No Punches',
    'employee-terminations': 'Employee Terminations',
    'employee-pay-rate-change': 'Employee Pay Rate Change',
    'employee-leave-of-absence': 'Employee Leave Of Absence',
    'total-employees': 'Total Employees',
    'employee-name': 'Employee Name',
    'employee-full-name': 'Employees full name including middle initial of name if it is entered',
    'first-name': 'First Name',
    'employee-first-name': 'Employees first name',
    'last-name': 'Last Name',
    'employee-last-name': 'Employees last name',
    'ssn': 'SSN',
    'employee-ssn': 'Employee Social Security Number',
    'geid': 'GEID',
    'employee-geid': 'McDonalds Global employee identifier',
    'primary-badge': 'Primary Badge',
    'primary-badge-number': 'Primary badge number',
    'secondary-badge': 'Secondary Badge',
    'secondary-badge-number': 'Secondary badge number',
    'last-punch-date': 'Last Punch Date',
    'last-punch-date-within-3-months': 'Last Punch within 3 months',
    'greater-than-3-months': '> 3 Months',
    'hire-date': 'Hire Date',
    'date-hired': 'Date Hired',
    'termination-date': 'Termination Date',
    'date-of-termination': 'Date of termination',
    'termination-reason': 'Termination Reason',
    'reason-of-termination': 'Reason of termination',
    'termination-code': 'Termination Code',
    'reason-of-termination-code': 'Reason of termination',
    'day-count': 'Day Count',
    'double-time-hours': 'Double Time Hours',
    'amount-of-hours-paid-double-the-regular-rate': 'Amount of hours paid double the regular rate',
    'overtime-hours': 'Over Time Hours',
    'amount-of-hours-paid-pay-and-a-half': 'Amount of hours paid pay and a half',
    'regular-time-hours': 'Regular Time Hours',
    'amount-of-hours-paid-with-normal-pay-rate': 'Amount of hours paid with normal pay rate',
    'total-dollars-paid': 'Total Dollars Paid',
    'amount-of-dollars-paid-during-the-pay-periods': 'Amount of dollars paid during the pay period(s)',
    'start-date': 'Start Date',
    'end-date': 'End Date',
    'pay-periods': 'Pay Periods',
    'start-of-new-pay-rate-and-job-title-code': 'Start of new Pay Rate and Job Title Code',
    'pay-rate': 'Pay Rate',
    'prior-pay-rate': 'Prior Pay Rate',
    'job-title-code': 'Job Title Code',
    'prior-job-title-code': 'Prior Job Title Code',
    'start-of-leave-of-absence': 'Start of leave of absence',
    'projected-return': 'Projected Return',
    'projected-return-of-leave-of-absence': 'Projected return of leave of absence',
    'actual-return': 'Actual Return',
    'actual-return-of-leave-of-absence': 'Actual return of leave of absence',
    'reason': 'Reason',
    'job-title-code-description-description': 'McDonalds Job Title Code Description',
    'job-title-code-description-header': 'Job Title Code Description',
    'date-of-birth-header': 'Date Of Birth',
    'date-of-birth-description': "Employee's date of birth",
    'street-address': 'Street Address',
    'city': 'City',
    'zip-code': 'Zip Code',
    'apt-number': 'Apt Number',
    'error-loading-report': 'There was an error loading the report.',
    'pay-period-end-date': 'Pay Period End Date',
    'payroll-ledger': 'Payroll Ledger',
    'omit-managers': 'Omit Managers',
    'show-documents-expiring-in-the-next': 'Show Documents Expiring In The Next',
    'day-scope': 'Day(s)',
    'week-scope': 'Week(s)',
    'month-scope': 'Month(s)',
    'scope': 'Scope',
    'student-permit-status-check': 'Student Permit Status Check',
    'date': 'Date',
    'less-than-20': 'Less Than 20',
  },
  es: {
    'all': 'Todos',
    'avg-weekly-hrs': 'Promedio de Horas Semanales',
    'only-active': 'Solo Activos',
    'employee-look-back': 'Revisión de Empleados',
    'search-here': 'Buscar aquí',
    'search-instructions': 'Busque utilizando las primeras 4 letras del apellido del empleado O los últimos 4 dígitos del SSN del empleado. Para apellidos de menos de 4 letras, agregue espacios hasta alcanzar 4 caracteres.',
    'employee-lookup': 'Búsqueda de Empleados',
    'please-enter-a-value': 'Por favor ingrese un valor',
    'please-enter-4-letters': 'Por favor ingrese 4 letras',
    'please-enter-4-numbers': 'Por favor ingrese 4 números',
    'please-do-not-use-special-characters': 'Por favor no use caracteres especiales',
    'employees': 'Empleados',
    'emp-pay-details': 'Detalles de Pago del Empleado',
    'federal': 'Fed.',
    'state': 'Estado',
    'local': 'Local',
    'marital-status': 'Estado Civil',
    'tax-exempt': 'Exento de Impuestos',
    'exemptions': 'Exenciones',
    'additional-withholding': 'Retención Adicional $',
    'fed-multi-job': 'Fed. Multi Trabajo',
    'fed-qual-child': 'Fed. Niño Calificado $',
    'fed-other-dep': 'Fed. Otro Dep $',
    'fed-total-dep': 'Fed. Total Dep $',
    'fed-other-income': 'Fed. Otro Ingreso',
    'fed-deductions': 'Fed. Deducciones',
    'hire-card-store-num': 'Ubicación',
    'new-hires-since': 'Nuevas Contrataciones Desde',
    'new-hires-found': 'Nuevas Contrataciones Encontradas',
    'new-hires': 'Nuevas Contrataciones',
    'overtime-audit': 'Auditoría de Horas Extras',
    'no-pay-details-found': 'No se encontraron detalles de pago.',
    'pay-cycle': 'Ciclo de Pago',
    'pay-cycle-status': 'Estado del Ciclo de Pago',
    'current-pay-cycle': 'Ciclo de Pago Actual',
    'most-recent-released': 'Más Reciente Liberado',
    'next-pay-cycle': 'Próximo Ciclo de Pago',
    'active-employee-with-no-punches': 'Empleado Activo sin Registros de Tiempo',
    'employee-terminations': 'Terminaciones de Empleados',
    'employee-pay-rate-change': 'Cambio de Tarifa de Pago del Empleado',
    'employee-leave-of-absence': 'Licencia de Ausencia del Empleado',
    'total-employees': 'Total de Empleados',
    'employee-name': 'Nombre del Empleado',
    'employee-full-name': 'Nombre completo del empleado, incluido el segundo nombre si está ingresado',
    'first-name': 'Primer Nombre',
    'employee-first-name': 'Primer nombre del empleado',
    'last-name': 'Apellido',
    'employee-last-name': 'Apellido del empleado',
    'ssn': 'Número de Seguro Social',
    'employee-ssn': 'Número de Seguro Social del Empleado',
    'geid': 'Identificador global de empleados de McDonalds (GEID)',
    'employee-geid': 'Identificador global de empleados de McDonalds',
    'primary-badge': 'Insignia Principal',
    'primary-badge-number': 'Número de insignia principal',
    'secondary-badge': 'Insignia Secundaria',
    'secondary-badge-number': 'Número de insignia secundaria',
    'last-punch-date': 'Última Fecha de Registro de Entrada',
    'last-punch-date-within-3-months': 'Último Registro de Entrada dentro de 3 meses',
    'greater-than-3-months': '> 3 Meses',
    'hire-date': 'Fecha de Contratación',
    'date-hired': 'Fecha de Contratación',
    'termination-date': 'Fecha de Terminación',
    'date-of-termination': 'Fecha de terminación',
    'termination-reason': 'Motivo de Terminación',
    'reason-of-termination': 'Motivo de terminación',
    'termination-code': 'Código de Terminación',
    'reason-of-termination-code': 'Código de motivo de terminación',
    'day-count': 'Cantidad de Días',
    'double-time-hours': 'Horas de Tiempo Doble',
    'amount-of-hours-paid-double-the-regular-rate': 'Cantidad de horas pagadas al doble de la tarifa regular',
    'overtime-hours': 'Horas Extras',
    'amount-of-hours-paid-pay-and-a-half': 'Cantidad de horas pagadas a tiempo y medio',
    'regular-time-hours': 'Horas de Tiempo Regular',
    'amount-of-hours-paid-with-normal-pay-rate': 'Cantidad de horas pagadas con tarifa normal',
    'total-dollars-paid': 'Total de Dólares Pagados',
    'amount-of-dollars-paid-during-the-pay-periods': 'Cantidad de dólares pagados durante el período de pago',
    'start-date': 'Fecha de Inicio',
    'end-date': 'Fecha de Fin',
    'pay-periods': 'Períodos de Pago',
    'start-of-new-pay-rate-and-job-title-code': 'Inicio de nueva tarifa de pago y código de título de trabajo',
    'pay-rate': 'Tarifa de Pago',
    'prior-pay-rate': 'Tarifa de Pago Anterior',
    'job-title-code': 'Código de Título de Trabajo',
    'prior-job-title-code': 'Código de Título de Trabajo Anterior',
    'start-of-leave-of-absence': 'Inicio de la licencia',
    'projected-return': 'Regreso Proyectado',
    'projected-return-of-leave-of-absence': 'Regreso proyectado de la licencia',
    'actual-return': 'Regreso Actual',
    'actual-return-of-leave-of-absence': 'Regreso real de la licencia',
    'reason': 'Razón',
    'job-title-code-description-description': 'Descripción del código de título de trabajo de McDonalds',
    'job-title-code-description-header': 'Descripción del código de título de trabajo',
    'date-of-birth-header': 'Fecha de Nacimiento',
    'date-of-birth-description': 'Fecha de nacimiento del empleado',
    'street-address': 'Dirección',
    'city': 'Ciudad',
    'zip-code': 'Código Postal',
    'apt-number': 'Número de Apartamento',
    'error-loading-report': 'Hubo un error al cargar el informe.',
    'pay-period-end-date': 'Fecha de Fin del Período de Pago',
    'payroll-ledger': 'Libro Mayor de Nómina',
    'omit-managers': 'Omitir Gerentes',
    'show-documents-expiring-in-the-next': 'Mostrar Documentos que Expiran en los Próximos',
    'day-scope': 'Día(s)',
    'week-scope': 'Semana(s)',
    'month-scope': 'Mes(es)',
    'scope': 'Ámbito',
    'student-permit-status-check': 'Verificación del Estado del Permiso Estudiantil',
    'date': 'Fecha',
    'less-than-20': 'Menos de 20',
  },
};
